export const concentratorType = {
  "fixed": "fixed",
  "portable": "portable",
  "fixed_portable": "fixed_portable",
  "transportable": "transportable"
};
